/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetCompanyRepresentativeEntity } from '../models/GetCompanyRepresentativeEntity';
import type { InitContractDto } from '../models/InitContractDto';
import type { InitContractEntity } from '../models/InitContractEntity';
import type { ListContractEntity } from '../models/ListContractEntity';
import type { SignContractDto } from '../models/SignContractDto';
import type { SignContractEntity } from '../models/SignContractEntity';
import type { VerifySignOtpDto } from '../models/VerifySignOtpDto';
import type { VerifySignOtpEntity } from '../models/VerifySignOtpEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EContractService {

    /**
     * @returns GetCompanyRepresentativeEntity
     * @throws ApiError
     */
    public static eContractControllerGetCompanyRepresentative(): CancelablePromise<GetCompanyRepresentativeEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/e-contract/company-representative',
        });
    }

    /**
     * @param requestBody
     * @returns InitContractEntity
     * @throws ApiError
     */
    public static eContractControllerInitContract(
        requestBody: InitContractDto,
    ): CancelablePromise<InitContractEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/e-contract/init',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data`,
            },
        });
    }

    /**
     * @param contractId Contract ID
     * @returns binary Contract file binary
     * @throws ApiError
     */
    public static eContractControllerDownloadContract(
        contractId: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/e-contract/{contractId}/download',
            path: {
                'contractId': contractId,
            },
        });
    }

    /**
     * @param contractId Contract ID
     * @param requestBody
     * @returns SignContractEntity
     * @throws ApiError
     */
    public static eContractControllerSignContract(
        contractId: string,
        requestBody: SignContractDto,
    ): CancelablePromise<SignContractEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/e-contract/{contractId}/sign',
            path: {
                'contractId': contractId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data`,
            },
        });
    }

    /**
     * @param contractId Contract ID
     * @param requestBody
     * @returns VerifySignOtpEntity
     * @throws ApiError
     */
    public static eContractControllerVerifySignOtp(
        contractId: string,
        requestBody: VerifySignOtpDto,
    ): CancelablePromise<VerifySignOtpEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/e-contract/{contractId}/sign/otp',
            path: {
                'contractId': contractId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data`,
            },
        });
    }

    /**
     * @param companyId Company ID to filter contracts
     * @param page Page number (1-based)
     * @param limit Number of items per page
     * @returns ListContractEntity
     * @throws ApiError
     */
    public static eContractControllerListContracts(
        companyId?: string,
        page: number = 1,
        limit: number = 10,
    ): CancelablePromise<ListContractEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/e-contract/list',
            query: {
                'companyId': companyId,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid request data`,
            },
        });
    }

}
